import ServiceTabComp from "../../components/ServiceComponents/ServiceTabComp";
import ArtificialIntiligence from "../icons/ArtificialIntiligence";
import DesignIcon from "../icons/DesignIcon";
import DevelopmentIcon from "../icons/DevelopmentIcon";
import GameDevelopment from "../icons/GameDevelopment";
import InternetOfThings from "../icons/InternetOfThings";
import MarketingIcon from "../icons/MarketingIcon";
import MobileIcon from "../icons/MobileIcon";
import SportsIcon from "../icons/SportsIcon";

export const offerCardMock = [
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
  {
    icon: <SportsIcon />,
    title: "Sports",
    descriptionText:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est ad quasi praesentium inventore aut cupiditate, doloremque omnis impedit. Quisquam perspiciatis quam amet recusandae pariatur, aut eos distinctio saepe commodi maxime!",
  },
];

export const tabMock = [
  {
    tabLabel: (
      <>
        <i>
          <DesignIcon />
        </i>
        <span>UI/UX Design</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <DevelopmentIcon />
        </i>
        <span>Web Development</span>
      </>
    ),

    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <MobileIcon />
        </i>
        <span>Mobile App Development</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <MarketingIcon />
        </i>
        <span>Digital Marketing</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <ArtificialIntiligence />
        </i>
        <span>Artificial Intelligence</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <InternetOfThings />
        </i>
        <span>Internet of Things</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
  {
    tabLabel: (
      <>
        <i>
          <DesignIcon />
        </i>
        <span>Blockchain Development</span>
      </>
    ),
    tabPanel: <ServiceTabComp />,
  },
];
